import { Image, get_prop } from 'utils'
import { TYPE } from 'network/server_tool'
import { REQUEST_TYPE } from 'network/net'
import {formatTimeString} from './table';

export default function( space, container, spec, settings ) {
    const view = new PIXI.Container;
    view.position.set(750, 0);
    container.addChild( view );

    const createLabel = (pos, text = '', size = 10 ) => {
        const t = new PIXI.Text(
            '',
            {
                fontSize : size,
                fill : 0xf2e200,
                align : 'left',
            },
        );
        t.position.set( pos[ 0 ], pos[ 1 ] );
        t.text = text;
        view.addChild( t )
        return t
    };

    const getLineY = (lineNumber) => {
        const lineHeight = 12;
        return 5 + lineNumber * lineHeight;
    }

    let pari_heading = createLabel([3, getLineY(0) + 12], 'КВИТАНЦИЯ ПАРИ №', 10);
    pari_heading.anchor.y = 1.0;
    let pari = createLabel([3 + 106, getLineY(0) + 12], '', 9);
    pari.anchor.y = 1.0;

    let step_heading = createLabel([171, getLineY(0) + 12], '/ШАГ', 10);
    step_heading.anchor.y = 1.0;
    let step = createLabel([171+23, getLineY(0) + 12], '', 9);
    step.anchor.y = 1.0;

    let event_outcome_heading = createLabel([3, getLineY(1)], 'Игра на исход события');
    let event_outcome = createLabel([3 + 110, getLineY(1)], settings.cheque.event );

    let event_heading = createLabel([3, getLineY(2)], 'СОБЫТИЕ №');
    let event = createLabel([3 + 70, getLineY(2)]);

    let step_done = createLabel([3, getLineY(3)], 'Шаг выполнен');
    let step_done_time = createLabel([3, getLineY(4)]);

    let event_time_heading = createLabel([3, getLineY(5)], 'Время наступления события');
    let event_time = createLabel([3, getLineY(6)]);

    let result_time_heading = createLabel([3, getLineY(7)], 'Время расчета результата шага');
    let result_time = createLabel([3, getLineY(8)]);

    space.s( 'state' )
        //.filter(state => state.type != TYPE.FINAL)
        .on( state => {
            const s = state.state;

            pari.text = settings.cheque.pari;
            step.text = get_prop( s, [ 'math_info', 'bet_id' ], '940.000004393796' );
            event_outcome.text = settings.cheque.event;
            event_heading.text = 'СОБЫТИЕ №';
            event.text = get_prop( s, [ 'math_info', 'source', 'id' ] );
            step_done_time.text = formatTimeString(get_prop( s, [ 'math_info', 'created' ], '' ).toString());
            event_time.text = formatTimeString(get_prop( s, [ 'math_info', 'source', 'created' ], '' ).toString());
            result_time.text = formatTimeString(get_prop( s, [ 'math_info', 'computed' ], '' ).toString());

    } );

    const clearLabels = () => {
        pari.text = '';
        step.text = '';
        event.text = '';
        step_done_time.text = '';
        event_time.text = '';
        result_time.text = '';
        event_heading.text = '';
        event_outcome.text = '';

    };


    space.s( 'pending' )
        .filter( p => p == REQUEST_TYPE.SPIN )
        .on( () => {
            clearLabels();
        } )

    // space.s( 'state' )
    //     .filter(state => state.type == TYPE.FINAL)
    //     .on(() => {
    //        clearLabels();
    //     })
}



// WEBPACK FOOTER //
// ./src/games/small_table.es6